import { render, staticRenderFns } from "./messageManagement.vue?vue&type=template&id=459cf391&scoped=true"
import script from "./messageManagement.vue?vue&type=script&lang=js"
export * from "./messageManagement.vue?vue&type=script&lang=js"
import style0 from "./messageManagement.vue?vue&type=style&index=0&id=459cf391&prod&lang=css"
import style1 from "./messageManagement.vue?vue&type=style&index=1&id=459cf391&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459cf391",
  null
  
)

export default component.exports